import React from "react";
import "./header-section.m.css";

const HeaderSection = ({ theme = {} }) => (
  <div styleName="header-container" style={{ backgroundColor: "transparent" }}>
    <img styleName="campaign-logo" src={theme.image_logo || "https://images.assettype.com/deccanherald/2026-05-09/74k4yppj/e-paper.png"} alt="logo" />
    <h1 styleName="campaign-heading" style={{ color: theme.heading_color }}>{theme.heading_text}</h1>
    <p styleName="campaign-subheading" style={{ color: theme.subheading_color }}>{theme.subheading_text}</p>
  </div>
);
export { HeaderSection };
